import React, { useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa";
import { formatRupees } from "../../../utils/inputsValidation";

const TableDownloadable = ({ capitalGainResult, selectedYr }) => {
    const [visibleIndexes, setVisibleIndexes] = useState({});
    
  const raw = capitalGainResult?.result || [];
  const result = raw.length > 0 ? raw.slice(0, -1) : [];

  const categoryMap = new Map();

  result.forEach((fund) => {
    const category = fund.Category || "Others";
    if (!categoryMap.has(category)) categoryMap.set(category, new Map());

    const fundMap = categoryMap.get(category);

    const key = fund.Fund;

    fundMap.set(key, {
      scheme: fund.Fund,
      isinNo: fund.FundDetail[0]?.ISIN_NO || "",
      folio: fund.FundDetail[0]?.Folio || "",
      shortGain: Number(fund.FundTotal?.STGain || 0),
      longGain: Number(fund.FundTotal?.LTGain || 0),
      totalGain: Number(fund.FundTotal?.Gainloss || 0),
    });
  });

  const categoryFunds = {};
  categoryMap.forEach((fundMap, category) => {
    categoryFunds[category] = Array.from(fundMap.values());
  });

  const grandTotals = Object.values(categoryFunds)
    .flat()
    .reduce(
      (acc, f) => {
        acc.short += f.shortGain;
        acc.long += f.longGain;
        return acc;
      },
      { short: 0, long: 0 }
    );

  return (
    <div id="htmlContainer">   {/* <-- REQUIRED FOR YOUR DOWNLOAD ACTIONS */}
      <div className="table-scroll-cgr-2 mt-4 d-none d-md-block">
        <table className="table">
          <thead className="tablehead">
            <tr>
              <th className="back-clrgreen txt-color-revers">Scheme Name</th>
              <th className="back-clrgreen txt-color-revers">ISIN Number</th>
              <th className="back-clrgreen txt-color-revers">Folio Number</th>
              <th className="back-clrgreen txt-color-revers">Short Term Gain</th>
              <th className="back-clrgreen txt-color-revers">Long Term Gain</th>
              <th className="back-clrgreen txt-color-revers">Total Gain/Loss</th>
            </tr>
          </thead>

          <tbody>
            {Object.entries(categoryFunds).map(([category, funds]) => {
              const categoryTotals = funds.reduce(
                (acc, f) => {
                  acc.short += f.shortGain;
                  acc.long += f.longGain;
                  return acc;
                },
                { short: 0, long: 0 }
              );

              return (
                <React.Fragment key={category}>
                  <tr className="headingdebt">
                    <td colSpan={6}>
                      <strong>{category} Funds</strong>
                    </td>
                  </tr>

                  {funds.map((fund, idx) => (
                    <tr key={idx}>
                      <td>{fund.scheme}</td>
                      <td>{fund.isinNo}</td>
                      <td>{fund.folio}</td>
                      <td>{fund.shortGain.toFixed(2)}</td>
                      <td>{fund.longGain.toFixed(2)}</td>
                      <td>{fund.totalGain.toFixed(2)}</td>
                    </tr>
                  ))}

                  <tr className="grey-bg total">
                    <td>{category} Total</td>
                    <td></td>
                    <td></td>
                    <td>{categoryTotals.short.toFixed(2)}</td>
                    <td>{categoryTotals.long.toFixed(2)}</td>
                    <td>{(categoryTotals.short + categoryTotals.long).toFixed(2)}</td>
                  </tr>
                </React.Fragment>
              );
            })}

            <tr className="grey-bg total">
              <td>Total Gain / Loss ({selectedYr})</td>
              <td></td>
              <td></td>
              <td>{grandTotals.short.toFixed(2)}</td>
              <td>{grandTotals.long.toFixed(2)}</td>
              <td>{(grandTotals.short + grandTotals.long).toFixed(2)}</td>
            </tr>
          </tbody>
        </table>

         {result.map((fund, fundIndex) => {
                        // Merge FundDetail by ISIN + Folio
                        const mergedDetails = {};
                        fund.FundDetail.forEach((detail) => {
                            const key = fund.Fund
                            if (!mergedDetails[key]) {
                                mergedDetails[key] = { ...detail, Transaction: [...detail.Transaction], Total: { ...detail.Total } };
                            } else {
                                mergedDetails[key].Transaction.push(...detail.Transaction);
                                mergedDetails[key].Total.SubAmount += detail.Total.SubAmount;
                                mergedDetails[key].Total.SubUnit += detail.Total.SubUnit;
                                mergedDetails[key].Total.RedempAmount += detail.Total.RedempAmount;
                                mergedDetails[key].Total.RedempUnit += detail.Total.RedempUnit;
                                mergedDetails[key].Total.Gainloss += detail.Total.Gainloss;
                            }
                        });
        
                        const detailsArray = Object.values(mergedDetails);
                        grandTotals.gainLoss += fund.FundTotal.Gainloss;
        
                        return (
                            <div key={fundIndex} className="table-scroll-cgr">
                                <table className="table">
                                    <thead>
                                        <tr className="odd">
                                            <th colSpan="13" >
                                                <p className="fs-14 fw-bold">{fund.Category} {fund.Sub_Category}</p>
                                                {/* <p className="fs-14 fw-bold">{fund.Fund}</p> */}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {detailsArray.map((detail, detailIndex) => {
                                            // const isVisible = visibleIndexes[`${fundIndex}-${detailIndex}`] ;
                                            const isVisible = true

                                            return (
                                                <React.Fragment key={detailIndex}>
                                                    <tr style={{ textAlign: "left" }}>
                                                        <th className="back-clrgreen txt-color-revers"
                                                         colSpan="13" 
                                                        //  onClick={() => toggleVisibility(`${fundIndex}-${detailIndex}`)} 
                                                         style={{ cursor: "pointer" }}>
                                                            {isVisible ? <FaMinus /> : <FaPlus />} {detail.Scheme} (Folio No: {detail.Folio}) (ISIN No: {detail.ISIN_NO})
                                                        </th>
                                                    </tr>
        
                                                    {isVisible && (
                                                        <>
                                                            <tr className="row3 green-bg port0">
                                                                <th colSpan="5" className="txt-color">Subscriptions</th>
                                                                <th colSpan="6" className="txt-color">Redemptions</th>
                                                                <th className="txt-color">Capital G/L</th>
                                                            </tr>
                                                            
                                                            <tr className="port0" >
                                                                {[
                                                                    "Trxn Type", "Date", "Amount", "Unit", "Cost",
                                                                    "Trxn Type", "Date", "Amount", "Unit", "Price", "Days", "Gain / Loss"
                                                                ].map((h, i) => <th className="back-clrgreen txt-color-revers" key={i}>{h}</th>)}
                                                            </tr>
                                                            {detail?.Transaction.map((tx, i) => (
                                                                <tr key={i}>
                                                                    <td>{tx["Sub Trans Type"]}</td>
                                                                    <td>{tx["Sub Date"]}</td>
                                                                    <td>{formatRupees(tx["Sub Amount"])}</td>
                                                                    <td>{tx["Sub Unit"]}</td>
                                                                    <td>{tx["Sub Cost"]}</td>
                                                                    <td>{tx["Redemp Trans Type"]}</td>
                                                                    <td>{tx["Redemp Date"]}</td>
                                                                    <td>{formatRupees(tx["Redemp Amount"])}</td>
                                                                    <td>{Number(tx["Redemp Unit"]).toFixed(2)}</td>
                                                                    <td>{formatRupees(tx["Redemp Price"])}</td>
                                                                    <td>{tx["Days"]}</td>
                                                                    {/* <td>{tx["Index Cost"] || "-"}</td> */}
                                                                    <td>{formatRupees(tx["Gainloss"])}</td>
                                                                </tr>
                                                            ))}
                                                            {/* <tr className="grey-bg total">
                                                                <td colSpan="2">Total</td>
                                                                <td>{Number(detail.Total.SubAmount).toFixed(2)}</td>
                                                                <td>{Number(detail.Total.SubUnit).toFixed(2)}</td>
                                                                <td colSpan="3"></td>
                                                                <td>{Number(detail.Total.RedempAmount).toFixed(2)}</td>
                                                                <td>{Number(detail.Total.RedempUnit).toFixed(2)}</td>
                                                                <td colSpan="2">Total Gain / Loss</td>
                                                                <td>{Number(detail.Total.Gainloss).toFixed(2)}</td>
                                                            </tr> */}
        
                                                             <tr className="grey-bg">
                                                                <td colSpan="2" className="fw-bold">{fund.Category} {fund.Sub_Category} Total</td>
                                                                <td>{Number(fund.FundTotal.SubAmount).toFixed(2)}</td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td>{Number(fund.FundTotal.RedempAmount).toFixed(2)}</td>
                                                                <td></td>
                                                                <td colSpan="2" className="fw-bold">Total Gain / Loss</td>
                                                                <td>{Number(fund.FundTotal.Gainloss).toFixed(2)}</td>
                                                            </tr>
                                                        </>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })}
        
                                        {/* <tr className="grey-bg">
                                            <td colSpan="2" className="fw-bold">{fund.Category} {fund.Sub_Category} Total</td>
                                            <td>{Number(fund.FundTotal.SubAmount).toFixed(2)}</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>{Number(fund.FundTotal.RedempAmount).toFixed(2)}</td>
                                            <td></td>
                                            <td colSpan="2" className="fw-bold">Total Gain / Loss</td>
                                            <td>{Number(fund.FundTotal.Gainloss).toFixed(2)}</td>
                                        </tr> */}
                                    </tbody>
                                </table>
                            </div>
                        );
                    })}
      </div>
    </div>
  );
};

export default TableDownloadable;
